package one.devsbox.www.ui.users.activity

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import one.devsbox.www.provider.LocalMeProvider
import one.devsbox.www.provider.MeProvider
import one.devsbox.www.tools.ArgsId
import tk.mallumo.compose.navigation.LocalNavigation
import tk.mallumo.compose.navigation.LocalNavigationArgs
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.args
import tk.mallumo.compose.navigation.viewmodel.viewModel

class UsersActivityCtx private constructor(
    val vm: UsersActivityVM,
    val nav: Navigation,
    val args: ArgsId,
    val me: MeProvider
) {
    val action get() = vm.action

    companion object {
        @Composable
        fun get(): UsersActivityCtx {
            val nav = LocalNavigation.current
            val args = LocalNavigationArgs.current.args<ArgsId>()
            val vm = nav.viewModel(UsersActivityVM::class)
            val me = LocalMeProvider.current
            return remember(args.id) {
                UsersActivityCtx(vm, nav, args, me).apply {
                    vm.setup(this)
                }
            }
        }
    }
}
